/* eslint-disable react/prop-types */
import { colors, strCode, userSegments } from "../../../consts";
import { t } from "../../../services";
import { userUtil } from "../../../utils";

import {
  FlexContainers,
  GradientLoader,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const UserInsightsTableColumns = [
  {
    Header: strCode.USER_TITLE,
    accessor: "email",
    Cell: ({ cell, cellWidth3, isLoading, searchedText }) => {
      const originalRow = cell.row.original;
      const userName = `${originalRow?.firstName ?? ""} ${originalRow?.lastName ?? ""}`;

      return (
        <CellWrapper width={`${cellWidth3}px`}>
          <WrapperContainer Container={FlexContainers.FlexColumn} alignItems="start">
            <TextOverflowWrapper
              maxWidth={`${cellWidth3}px`}
              style={{
                fontWeight: "600",
                color: colors.RAISIN_100
              }}>
              {isLoading ? (
                <GradientLoader width={308} height={24} animationDuration={16} />
              ) : (
                userName
              )}
            </TextOverflowWrapper>

            <TextOverflowWrapper
              maxWidth={`${cellWidth3}px`}
              highlightedText={searchedText}
              style={{
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "26px",
                color: colors.RAISIN_70
              }}>
              {cell.value}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.SEGMENT_TITLE,
    accessor: "segment",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const segmemntName = userSegments.find((segment) => segment.id === cell.value)?.value ?? "";

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : (
              t(segmemntName)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CONVERSION_TYPE_TITLE,
    accessor: "conversionType",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const conversionType = cell.value ? strCode.CONVERSION_TITLE : strCode.NON_CONVERSION_TITLE;

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : (
              t(conversionType)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.USER_SINCE_TITLE,
    accessor: "createdAtTs",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const userSince = userUtil.formatUserLoginInfoTimestamp(cell.value);

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : (
              userSince
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.MARKETS_LABEL,
    accessor: "markets",
    Cell: ({ cell, cellWidth10, isLoading }) => {
      const markets = cell?.value;

      return (
        <CellWrapper width={`${cellWidth10}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={68} height={24} animationDuration={32} />
            ) : Array.isArray(markets) ? (
              markets?.join(", ")
            ) : null}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
